import { Component, ViewChild } from '@angular/core';
import { TransactionTableViewComponent } from '../../../components/transaction/transaction-table-view/transaction-table-view.component';
import { StorageService } from '../../../core/storage/storageService';
import { TableView } from '../../../components/ui/filterable-table/tableView';
import { TransactionFacade } from '../../../models/transactions/transactionFacade';
import { MatDialog } from '@angular/material/dialog';
import { TransactionDialogComponent } from '../../../components/transaction/transaction-dialog/transaction-dialog.component';
import { AccessManager } from '../../../components/ui/access-manager/access-manager';

@Component({
  selector: 'app-merchant-transactions-page',
  templateUrl: './merchant-transactions-page.component.html',
  standalone: false,
})
export class RecentTransactionsComponent {

  @ViewChild('transactionsTable') transactionTableControl:
  | TransactionTableViewComponent
  | undefined;
  namespace: string = AccessManager.AUTH_SELECT_MERCHANT_TRANSACTIONS;

  transactionsTableView: any;

  transactionsTableOptions: any = {
    paginated: false,
  };

  constructor(private storage: StorageService, private dialog: MatDialog, private access: AccessManager) {
    this.transactionsTableView = new TableView(TransactionTableViewComponent);
  }

  ngAfterViewInit() {
    this.transactionsTableOptions.userId = this.storage.getCurrentUser()?.id;
    this.transactionsTableOptions.merchantId =
      this.storage.getSelectedLocation()?.id;
    this.transactionsTableView = new TableView(
      TransactionTableViewComponent,
    );
    this.transactionTableControl?.setOptions(
      this.transactionsTableOptions,
    );
  }

  handleTransactionSelected(transaction: TransactionFacade) {
    const dialogRef = this.dialog.open(TransactionDialogComponent, {
      width: '500px',
      data: { transaction: transaction },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('result', result);
    });
  }
}
